function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M7.7 2.1c-.5.5-.9 1.1-1.2 1.9V1.7h-6v.5h1.4v11H.5v.5h7.1v-.5H6.5V6.3c0-1 .2-1.9.6-2.6.4-.7.9-1.1 1.4-1.1.4 0 .6.1.7.4.2.4.3 1 .3 2v8.2h-1v.5h7.1v-.5h-1.4V5.6c0-2.8-1.3-4.2-3.9-4.2-1.2 0-2 .3-2.6.7z"
}));

var _ref3 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  overflow: "visible",
  fill: "#f4f2ed"
});

var _ref4 = /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a",
  overflow: "visible"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "M.5-6.1h92.8v20.4H.5z"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c",
  overflow: "visible",
  fill: "#f4f2ed"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "d"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c",
  overflow: "visible"
})));

var SvgNoScore = function SvgNoScore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoScore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-score.1f30df51.svg";
export { ForwardRef as ReactComponent };